const Option = () => null;
Option.isSelectOption = true;
Option.displayName = 'WdSelectOption';
export default Option;
